import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=6cce3a1f&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UserForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=6cce3a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce3a1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cce3a1f')) {
      api.createRecord('6cce3a1f', component.options)
    } else {
      api.reload('6cce3a1f', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=6cce3a1f&scoped=true&", function () {
      api.rerender('6cce3a1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/UserForm.vue"
export default component.exports